// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 768px){
    .section{
        flex-wrap: wrap;
        flex-direction: column;
        align-items: center;
        text-align: center;
    }
    .section #eventPhoto{
        width: 65%;
    }
}
#summaryBox{
    width: 50%;
    display: flex;
    margin: 0 auto;
    justify-content: center;
}
#summary{
    font-size: 24px;
}
.section{
    display: flex;
    border: 1px solid rgb(186, 35, 35);
    background-color: rgb(255, 255, 255);
}
.innerSec{
    display: flex;
    border: 1px solid rgb(53, 125, 124);
    flex-direction: column;
    width: 65%;
}
#eventPhoto{
    width: 25%;
}
#title, #info{
    font-size: 24px;
}
#title{
    height: 25%;
    margin-bottom: 20px;
    font-weight: bold;
}
#info{
    margin-top: -10px;
}`, "",{"version":3,"sources":["webpack://./src/CSS/PaE.css"],"names":[],"mappings":"AAAA;IACI;QACI,eAAe;QACf,sBAAsB;QACtB,mBAAmB;QACnB,kBAAkB;IACtB;IACA;QACI,UAAU;IACd;AACJ;AACA;IACI,UAAU;IACV,aAAa;IACb,cAAc;IACd,uBAAuB;AAC3B;AACA;IACI,eAAe;AACnB;AACA;IACI,aAAa;IACb,kCAAkC;IAClC,oCAAoC;AACxC;AACA;IACI,aAAa;IACb,mCAAmC;IACnC,sBAAsB;IACtB,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB","sourcesContent":["@media (max-width: 768px){\n    .section{\n        flex-wrap: wrap;\n        flex-direction: column;\n        align-items: center;\n        text-align: center;\n    }\n    .section #eventPhoto{\n        width: 65%;\n    }\n}\n#summaryBox{\n    width: 50%;\n    display: flex;\n    margin: 0 auto;\n    justify-content: center;\n}\n#summary{\n    font-size: 24px;\n}\n.section{\n    display: flex;\n    border: 1px solid rgb(186, 35, 35);\n    background-color: rgb(255, 255, 255);\n}\n.innerSec{\n    display: flex;\n    border: 1px solid rgb(53, 125, 124);\n    flex-direction: column;\n    width: 65%;\n}\n#eventPhoto{\n    width: 25%;\n}\n#title, #info{\n    font-size: 24px;\n}\n#title{\n    height: 25%;\n    margin-bottom: 20px;\n    font-weight: bold;\n}\n#info{\n    margin-top: -10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
